import { Form } from 'antd';
import { RestInputContext } from 'components/form/RestInputContext';
import React from 'react';
import { DynamicObjectType } from 'types/commons';

interface RestFilterFormProps {
  filter?: DynamicObjectType;
  format?: (value: DynamicObjectType) => void;
  children: React.ReactElement;
  retrieveList: (values) => void;
}

export default function RestFilterForm({
  filter,
  children,
  retrieveList,
  format = (values) => values,
}: RestFilterFormProps) {
  const [form] = Form.useForm();
  
  const onValuesChange = (_, values) => {
    retrieveList(format(values));
  };

  return (
    <Form onValuesChange={onValuesChange} layout="vertical" form={form}>
      <RestInputContext.Provider
        value={{
          form,
          record: filter || {},
        }}
      >
        {children}
      </RestInputContext.Provider>
    </Form>
  );
}
